<template>
  <div
  v-if="false"
  class="jin-list"
  :style="style">
    <div class="jin-list__wrap">
      <div class="jin-list__box" ref="box">
        <div class="jin-list__h">
          <h3 class="jin-list__title">
            <span>相关推荐</span>
          </h3>
          <ul class="jin-list-nav" ref="navWrap">
            <li
            :ref="`nav-${key}`"
            class="jin-list-nav__item"
            v-for="(item, key) in list"
            :key="key"
            :class="{'is-active': type === key}"
            @click="getDatas(key)">{{ getNavTitle(key) }}</li>
          </ul>
          <a
          :href="`https://v.jin10.com/list.html?cate=${id}`"
          target="_blank"
          class="jin-list__more">查看更多</a>
        </div>
        <div class="jin-list__b">
          <ul
          class="jin-news">
            <li
            class="jin-news__item"
            v-for="(data, index) in datas"
            :key="index">
              <template v-if="data">
                <div class="jin-news__h">
                  <img :src="data.thumb" :alt="data.title">
                  <div class="jin-news-mask">
                    <div class="jin-news-mask__box">
                      <a :href="`https://v.jin10.com/details.html?id=${data.id}`" target="_blank" class="jin-news__btn">
                        <icon type="play"></icon>
                      </a>
                      <span
                      class="jin-news__btn">
                        <icon type="share"></icon>
                        <share-button :url="`https://v.jin10.com/details.html?id=${data.id}`" :title="data.title"></share-button>
                      </span>
                    </div>
                  </div>
                </div>
                <div
                class="jin-news__b">
                  <a :href="`https://v.jin10.com/details.html?id=${data.id}`" target="_blank">
                    <div class="jin-news__info">
                      <span>{{ data.title_sub }}</span>
                    </div>
                    <h3
                    class="jin-news__title"
                    :class="{'is-none-subtitle': !data.title_sub}">{{ data.title }}</h3>
                  </a>
                </div>
              </template>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { fetch } from '@/commons/fetch'
import { requestUrl } from '@/commons/config'

export default {
  name: '',
  computed: {
    ...mapState(['topNavs']),
    ...mapGetters([
      'options',
      'liveType'
    ]),
    list () {
      return this.options.newsConfig || {}
    },
    style () {
      if (this.paddingTop) {
        return {
          paddingTop: this.paddingTop
        }
      }
    }
  },
  watch: {
    liveType (v) {
      this.type = v
      this.getDatas(v)
    },
    type (v) {
      const el = this.$refs[`nav-${v}`] && this.$refs[`nav-${v}`][0]
      if (el) {
        const wrap = this.$refs.navWrap
        const wrapWidth = wrap.offsetWidth
        const wrapScrollLeft = wrap.scrollLeft
        const elWidth = el.offsetWidth
        const elLeft = el.offsetLeft
        const elRight = elLeft + elWidth
        const wrapRight = wrapWidth + wrapScrollLeft
        if (elLeft < wrapScrollLeft) {
          wrap.scrollLeft = elLeft
        } else if (elRight > wrapRight) {
          wrap.scrollLeft = elRight - wrapWidth
        }
      }
    }
  },
  data () {
    return {
      inited: false,
      isLoading: false,
      timer: null,
      datas: [],
      type: '',
      id: 21,
      paddingTop: 0
    }
  },
  created () {
    // console.log(this.options)
    window.addEventListener('resize', this.resizeHandle, false)
  },
  destroyed () {
    window.removeEventListener('resize', this.resizeHandle, false)
  },
  methods: {
    getDatas (type) {
      if (this.isLoading) {
        return false
      }
      let id = this.list[type]
      this.isLoading = true
      this.type = id ? type : 'tv'
      this.id = id || 21
      this.datas = []
      fetch({
        type: 'jsonp',
        url: requestUrl.history,
        params: {
          id: this.id
        },
        callback: () => {
          this.isLoading = false
        },
        success: ({ data }) => {
          if (!data.length) {
            return false
          }
          data.length = 3
          this.datas = data.map(item => {
            if (!item.thumb.includes('/lite'))item.thumb = item.thumb + '/lite'
            if (!item.thumb_mobile.includes('/lite'))item.thumb = item.thumb_mobile + '/lite'
            return item
          })
          // console.log(222, this.datas)

          if (!this.inited) {
            this.$nextTick(() => {
              this.calculateThePadding()
              this.inited = true
            })
          }
        },
        error: () => {
          this.isLoading = false
        }
      })
    },
    calculateThePadding () {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        const $el = this.$refs.box
        this.paddingTop = `${$el.offsetHeight / $el.offsetWidth * 100}%`
      }, 200)
    },
    resizeHandle () {
      this.calculateThePadding()
    },
    getNavTitle (key) {
      const findNav = this.topNavs.find(item => item.type === key)
      return (findNav ? findNav.name : '') || this.options[key].title
    }
  }
}
</script>



// WEBPACK FOOTER //
// list.vue?5b6a9c00